import { Component } from '@angular/core';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';

@Component({
    selector: 'odoo-connector-panel',
    templateUrl: './odoo.connector.panel.html'
})
export class OdooConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Odoo',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.OdooInfo',
            ControlType: OdooConnectorPanel,
            Default: {
                Edition: 0
            }
        };
    }
}
